import _ from 'lodash';
import React from 'react';
import * as Styled from './styled';
import palette from '@mlc/mlc-palette';
import Search from './Search/Search';
import SiteTools from './SiteTools/SiteTools';
import AdviserInformation from '../../../logic/domains/adviserInformation.domain';
import topMenuTestIds from './TopMenu.elements';
import { Card, Col, Grid, Row } from '@mlc/web-ui-toolkit';

interface Props {
	siteToolsData: SiteMenuLinksType[];
	adviserInformation: AdviserInformation;
}

export type SiteMenuLinksType = {
	title: string;
	pageUrl: string;
};

const TopMenu: React.FunctionComponent<Props> = ({
	siteToolsData,
	adviserInformation,
}: Props) => {
	return (
		<Card backgroundColor={palette.mlcCore}>
			<Grid data-id={topMenuTestIds.topMenuContainer}>
				<Row>
					<Col col={true}>
						<Styled.SiteToolsLinks data-id={topMenuTestIds.topMenuLinks}>
							{_.map(siteToolsData, (itemNav: SiteMenuLinksType) => {
								return (
									<Styled.SiteToolsLinkItem key={itemNav.pageUrl}>
										<Styled.SiteMenuLinks
											href={itemNav.pageUrl}
											target="_blank"
											data-analytics-id={`header-${_.kebabCase(itemNav.title)}`}
										>
											{itemNav.title}
										</Styled.SiteMenuLinks>
									</Styled.SiteToolsLinkItem>
								);
							})}
						</Styled.SiteToolsLinks>
					</Col>
					<Styled.SearchCol col={true}>
						<Search />
						<SiteTools adviserInformation={adviserInformation} />
					</Styled.SearchCol>
				</Row>
			</Grid>
		</Card>
	);
};

export default TopMenu;
